import React, { useState, useEffect } from "react";
import { Avatar_02 } from "../../Routes/ImagePath";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import Select from "react-select";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import EssFullWidthModal from "components/modelpopup/baseModal"
import { Button } from "components/Button";
import { Controller } from "react-hook-form";
import {  useSelector } from 'react-redux';
import FilterSelect from "components/Form/filterSelect";
import { changeEmployeeDetail, createAddressApi, updateAddressApi } from "api/services/employee";
import {  toast, Bounce } from 'react-toastify';
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css"; // Use Bootstrap styles

const PersonalInformationModelPopup = ({
    infoModal,
    setInfoModal,
    selectedInfo,
    fetchInfo,
    

}) => {
 
  const [loading, setLoading]=  useState(false);



  const [nationalityOption, setNationalityOption] = useState([]);

  
  const { nationality, nationalityLoading } = useSelector(
    (state) => state.common
  );

  useEffect(() => {
    let _nationality = nationality.map((item) => {
      return {
        label: item.name,
        value: item.id,
      };
    });

    setNationalityOption(_nationality);
  }, [nationality]);





// ✅ Yup Validation Schema
const schema = yup.object().shape({
  blood_group: yup.object(),
  marital_status: yup.object(),
  no_of_dependent: yup.string(),
  private_email: yup.string().email(),
  mobile_no: yup.string(),
  // address_1: yup.string(),
  // address_2: yup.string(),

  city: yup.string(),

});

const {
  register,
  handleSubmit,
  formState: { errors },
  reset,
  control,
  setError,
  setValue
} = useForm({
  resolver: yupResolver(schema), // ✅ Apply Yup validation
  defaultValues:{

  }
});

const statusOptions = [
   {value:"single",label: "Single"},
   {value:"married",label: "Married"},
   {value:"divorced", label:"Divorced"},
  {value:"widowed", label:"Widowed"}
]
const bloodGroups = [
  { value: "A+", label: "A Positive (A+)" },
  { value: "A-", label: "A Negative (A-)" },
  { value: "B+", label: "B Positive (B+)" },
  { value: "B-", label: "B Negative (B-)" },
  { value: "O+", label: "O Positive (O+)" },
  { value: "O-", label: "O Negative (O-)" },
  { value: "AB+", label: "AB Positive (AB+)" },
  { value: "AB-", label: "AB Negative (AB-)" },
];


useEffect(()=>{
  if(infoModal && selectedInfo?.id){
    setValue("blood_group", bloodGroups.find(item=> item.value.toLowerCase() == selectedInfo?.blood_group?.toLowerCase()) )
    setValue("no_of_dependent", selectedInfo?.no_of_dependent)
    setValue("marital_status", statusOptions.find(item=> item.value==selectedInfo?.marital_status ))
    setValue("private_email", selectedInfo?.contact?.private_email)
    setValue("mobile_no", selectedInfo?.contact?.mobile_no)
    // setValue("address_1", selectedInfo?.contact?.address_1)
    // setValue("address_2", selectedInfo?.contact?.address_2)
    setValue("city", selectedInfo?.contact?.city)

  }
  

}, [infoModal, selectedInfo, nationalityOption])


const handleReset = () => {
  // reset({
  //   name: "",
  //   address_1: "",
  //   address_2: "",
  //   city: "",
  //   country: "",
  //   emergency_contact_name: "",
  //   emergency_contact_number: "",
  // });
  reset();
};


  const onSubmit = async (data) => {

    let payload = {
      ...data,
      marital_status: data?.marital_status?.value,
      blood_group: data?.blood_group?.value,
    }

    if(selectedInfo?.id){
      updateInfoData(payload)
    }else{
      // createAddressData(payload)
    }
 

  };
  const updateInfoData = (payload) => {
    setLoading(true)
    changeEmployeeDetail(selectedInfo?.id,payload).then(response=>{

      setInfoModal(false)
      setLoading(false)
      handleReset()
      toast.success('Personal information updated!', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
        });
        fetchInfo()
    }).catch(e=>{
      try{
        console.log(e.response.data, "EEEEE")
        // let response = e.response?.data?.error || "Error updating leave status!"
        setLoading(false)
    

      if(e.response.data){
        Object.entries(e.response.data).forEach(([k, v]) => {
          console.log(typeof v,k, "EEEEE")
          setError(k,
            {
              type: 'manual',
              message: v.join(", ")
            }
             )
        })
      }
      }catch(err){
        console.log(err, "LLLLLLL")
        let response = e.response?.data?.error || "Error updating personal information!"
        setLoading(false)
          toast.error(response, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
            });
        
      }

    })
  }
 
  // const createAddressData = (payload) => {
  //   setLoading(true)
  //   createAddressApi(payload).then(response=>{

  //     setInfoModal(false)
  //     setLoading(false)
  //     handleReset()
  //     toast.success('Emergency contact created!', {
  //       position: "top-right",
  //       autoClose: 5000,
  //       hideProgressBar: false,
  //       closeOnClick: false,
  //       pauseOnHover: true,
  //       draggable: true,
  //       progress: undefined,
  //       theme: "light",
  //       transition: Bounce,
  //       });
  //       fetchInfo()
  //   }).catch(e=>{
  //     try{
  //       console.log(e.response.data, "EEEEE")
  //       // let response = e.response?.data?.error || "Error updating leave status!"
  //       setLoading(false)
    

  //     if(e.response.data){
  //       Object.entries(e.response.data).forEach(([k, v]) => {
  //         console.log(typeof v,k, "EEEEE")
  //         setError(k,
  //           {
  //             type: 'manual',
  //             message: v.join(", ")
  //           }
  //            )
  //       })
  //     }
  //     }catch(err){
  //       console.log(err, "LLLLLLL")
  //       let response = e.response?.data?.error || "Error creating address!"
  //       setLoading(false)
  //         toast.error(response, {
  //           position: "top-right",
  //           autoClose: 5000,
  //           hideProgressBar: false,
  //           closeOnClick: false,
  //           pauseOnHover: true,
  //           draggable: true,
  //           progress: undefined,
  //           theme: "light",
  //           transition: Bounce,
  //           });
        
  //     }

  //   })
  // }

  return (
    <>
      <EssFullWidthModal
        mask={false}
        title={selectedInfo ? "Update Personal Information" : "Create Personal Information"}
        // style={{ top: 100 }}
        open={infoModal}
        width={"40%"}
        footer={[]}
        onCancel={() => {
            setInfoModal(false)
            handleReset()
        
        }}
        className="full-width-modal"
     >
        <div className="modal-content">
            
            <div className="modal-body">
            <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
                {/* 🔹 Name (Full width on mobile, Half on Desktop) */}
                <div className="col-12 col-md-6 mb-3">
                  <label className="form-label">Blood Group</label>
                  <Controller
                    name={`blood_group`}
                    control={control}
                    render={({ field: { value, onChange } }) => (
                      <FilterSelect
                        {...register("blood_group")}
                        isClearable={true}
                        onChange={onChange}
                        optionLabel={"label"}
                        optionValue={"value"}
                        options={bloodGroups}
                        isLoading={false}
                        value={value}
                        placeholder={"Blood group"}
                      />
                    )}
                  />
                  {/* <input type="text" className="form-control" {...register("blood_group")} /> */}
                  {errors.blood_group && <small className="text-danger">{errors.blood_group.message}</small>}
                </div>
                <div className="col-12 col-md-6 mb-3">
                  <label className="form-label">No of Children</label>
                  <input type="text" className="form-control" {...register("no_of_dependent")} />
                  {errors.no_of_dependent && <small className="text-danger">{errors.no_of_dependent.message}</small>}
                </div>
              </div>


              <div className="row">
               
                <div className="col-12 col-md-6 mb-3">
                  <label className="form-label">Marital Status</label>
                  <Controller
                    name={`marital_status`}
                    control={control}
                    render={({ field: { value, onChange } }) => (
                      <FilterSelect
                        {...register("marital_status")}
                        isClearable={true}
                        onChange={onChange}
                        optionLabel={"label"}
                        optionValue={"value"}
                        options={statusOptions}
                        isLoading={false}
                        value={value}
                        placeholder={"Martial status"}
                      />
                    )}
                  />
                  {errors.marital_status && <small className="text-danger">{errors.marital_status.message}</small>}
                </div>

                <div className="col-12 col-md-6 mb-3">
                  <label className="form-label">Phone Number</label>
                  <Controller
                    name="mobile_no"
                    control={control}
                    rules={{
                      required: "Phone number is required",
                      minLength: {
                        value: 10,
                        message: "Enter a valid phone number",
                      },
                    }}
                    render={({ field }) => (
                      <PhoneInput
                        {...field}
                        country={"us"} // Default country
                        enableSearch={true}
                        inputClass="form-control w-100" // Bootstrap input class
                      />
                    )}
                  />
                  {errors.mobile_no && <small className="text-danger">{errors.mobile_no.message}</small>}
                </div>


              </div>


              <div className="row">
               
               <div className="col-12 col-md-6 mb-3">
                 <label className="form-label">Email</label>
                 <input type="text" className="form-control" {...register("private_email")} />
                  {errors.private_email && <small className="text-danger">{errors.private_email.message}</small>}

               </div>
{/* 
               <div className="col-12 col-md-6 mb-3">
               <label className="form-label">Address 1</label>
                 <input type="text" className="form-control" {...register("address_1")} />
                  {errors.address_1 && <small className="text-danger">{errors.address_1.message}</small>}

               </div> */}
  <div className="col-12 col-md-6 mb-3">
               <label className="form-label">City</label>
                 <input type="text" className="form-control" {...register("city")} />
                  {errors.city && <small className="text-danger">{errors.city.message}</small>}

               </div>


             </div>

             <div className="row">
               
               {/* <div className="col-12 col-md-6 mb-3">
                 <label className="form-label">Address 2</label>
                 <input type="text" className="form-control" {...register("address_2")} />
                  {errors.address_2 && <small className="text-danger">{errors.address_2.message}</small>}

               </div> */}

             

             </div>
            
              {/* 🔹 Submit Button */}
              <div className="submit-section">
                  <Button
                    loading={loading}
                    disabled={loading}
                    className="btn btn-primary submit-btn"
                    type="submit"
                    label="Submit"
                  />
                </div>
            </form>
            </div>
          </div>
     </EssFullWidthModal>

    

    </>
  );
};

export default PersonalInformationModelPopup;
